/**
 * Alpine.js data component for managing the paused banner ad
 */
export function pausedBannerAd(config: PausedBannerAdConfig = {}) {
    return {
        adClass: config.adClass || '',
        adDataKey: config.adDataKey || '',
        adScriptSrc: config.adScriptSrc || 'https://deliver.ptgncdn.com/5a47a834.js',
        isVisible: false,

        init() {
            this.isVisible = false;
        },

        show() {
            // Only proceed on desktop
            if (window.innerWidth < 768) return;

            this.isVisible = true;
            this.renderAd();
        },

        hide() {
            this.isVisible = false;
            this.removeAd();
        },

        renderAd() {
            const container = this.$refs.adContainer;
            if (!container) return;

            container.innerHTML = '';

            if (this.adClass && this.adDataKey) {
                const ins = document.createElement('ins');
                ins.className = this.adClass;
                ins.dataset.key = this.adDataKey;
                ins.style.width = '100%';
                ins.style.height = '100%';
                container.appendChild(ins);

                const script = document.createElement('script');
                script.src = this.adScriptSrc;
                container.appendChild(script);
            }
        },

        removeAd() {
            const container = this.$refs.adContainer;
            if (container) {
                container.innerHTML = '';
            }
        },
    };
}
